import React, { useState, useContext, useEffect } from "react";
import StepperNavigationButtons from "../../StepperNavigationButtons/StepperNavigationButtons";
import { EWContext } from "../../../context/EWContext";
import FormBuilder from "../FormBuilder/FormBuilder";
import { getFormAnswers } from "../../../utils/utils";
import { getContractorDetailsService } from "../../../services/services";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import { isEmpty } from "lodash";

function ContractorDetailsForm(props) {
    const [accountState, setAccountState] = useContext(EWContext);

    const {
        questions: { contractor: questions },
        answers: { contractor: answers },
        stateOptions,
        urlToRedirect,
        conditionSpecificBehaviors,
    } = accountState;

    const {
        cr_contractorEntityType,
        cr_InstallationType2,
        cr_InstallationType1,
        cr_summit_utilities,
    } = conditionSpecificBehaviors || {};

    const [loading, setLoading] = useState(false);
    const [errorFields, setErrorFields] = useState(true);
    const [isValidForm, setIsValidForm] = useState(false);
    const [customOptions, setCustomOptions] = useState([]);
    const [contractorFormAnswers, setContractorFormAnswers] = useState(answers);
    const { group, handleNext, handleBack } = props;
    let isRequired = false;

    useEffect(() => {
        if (answers) {
            if (answers.length > 0) {
                const formIsAnswered = answers.every((field) => {
                    
                    if(field.type === "date") {
                        if(field.value == "Invalid Date") {
                          return false
                        }
                        let dateRange =  questions.find(ques => ques.id === field.id).field.rangeDates;

                        if(dateRange?.minDate?.date) {

                            if(new Date(field.value ) < new Date(dateRange.minDate.date)){
                                return false
                            }
                        } 

                        if(dateRange?.maxDate?.date) {
                            if(new Date(field.value) > new Date(dateRange.maxDate.date)) {
                                return false
                            }
                        }
                    }

                    if (typeof field.value === "object") {
                        return field ? (field.required ? field.value.value !== "" : true) : false;
                    }
                    return field ? (field.required ? field.value !== "" : true) : false;
                });
                setErrorFields(!formIsAnswered);
            } else {
                const questionsRequired = questions.some((question) =>
                    question ? question.required : false
                );
                setErrorFields(questionsRequired);
            }
        }
    }, [answers, questions]);

    useEffect(() => {
        if (isValidForm) {
            // Saving answers in the App state
            setAccountState((prevAccountState) => ({
                ...prevAccountState,
                ...{
                    contractorAnswers: [...contractorFormAnswers],
                    submitAttempts: 0,
                },
            }));
            setLoading(false);
            handleNext(true);
        }
    }, [isValidForm, contractorFormAnswers, setAccountState, handleNext]);

    const getContractorInformation = async (contractorName) => {
        if (contractorName && contractorName.length > 2) {
            const res = await getContractorDetailsService(
                urlToRedirect,
                contractorName
            ).catch((error) => {
                console.log(error);
                return;
            });

            try {
                const contractorOptions = res.map((contractor) => ({
                    value: contractor.company_name,
                    label: contractor.company_name,
                    extraValues: {
                        ...contractor.address,
                        contractorPhone: contractor.phone_number,
                    },
                }));
                setCustomOptions(contractorOptions || []);
            } catch (error) {
                console.log(error);
            }
        }
    };

    const setRequiredFields = (userAnswers) => {
        userAnswers.forEach((userData) => {
            const { id, value } = userData;
            if (
                id === cr_contractorEntityType &&
                value === cr_InstallationType2
            ) {
                isRequired = true;
            } else if (
                id === cr_contractorEntityType &&
                value === cr_InstallationType1
            ) {
                isRequired = false;
            }
        });
        questions.forEach((question) => {
            const { id } = question;
            if (id !== cr_contractorEntityType) {
                question.required = isRequired;
            }
        });
    };

    const normalizePhoneNumber = (phone) => {
        if (!phone) return "";
        return phone.replace(/\D/g, "");
    };

    const handleOnFormAnswered = async (builderAnswers, lastFieldModified) => {
        let newAnswers = { ...builderAnswers };
        const { id, value, textValue } = lastFieldModified;
        if (id === "contractorName" && textValue) {
            getContractorInformation(textValue);
            const extraValues = value?.extraValues;
            if (extraValues && !isEmpty(extraValues)) {
                const { street, city, state, zip, contractorPhone } =
                    extraValues;
                let stateValue = stateOptions.find(
                    (element) => element.value === state
                );
                const newAddress = {
                    address: { value: street, textValue: street },
                    city: { value: city, textValue: city },
                    zip: { value: zip, textValue: zip },
                    state: {
                        value: stateValue.value || "",
                        textValue: stateValue.value || "",
                    },
                };
                newAnswers = {
                    ...newAnswers,
                    ...newAddress,
                    contractorPhone: {
                        ...newAnswers.contractorPhone,
                        value: normalizePhoneNumber(contractorPhone),
                        textValue: normalizePhoneNumber(contractorPhone),
                    },
                };
                const formAnswers = getFormAnswers(newAnswers, questions);
                setContractorFormAnswers(formAnswers);
                setAccountState((prevAccountState) => ({
                    ...prevAccountState,
                    answers: {
                        ...prevAccountState.answers,
                        contractor: [...formAnswers],
                    },
                }));
            }
        }

        let formAnswers = getFormAnswers(newAnswers, questions);
        formAnswers = formAnswers.map((item)=>{
            if(item.id === "state"){
                item["textValue"] = item["value"]
            }
            return item;
        })
        cr_summit_utilities && setRequiredFields(formAnswers);
        const formIsAnswered = formAnswers.every((field) => {
            const { required, value } = field;
            field.required = (cr_summit_utilities && isRequired) || required;
            if (typeof value === "object") {
                return field.required ? value.value !== "" : true;
            }
            return field.required ? value !== "" : true;
        });

        if (formIsAnswered) {
            setErrorFields(false);
            setContractorFormAnswers(formAnswers);
            setAccountState((prevAccountState) => ({
                ...prevAccountState,
                answers: {
                    ...prevAccountState.answers,
                    contractor: [...formAnswers],
                },
            }));
        } else {
            setErrorFields(true);
        }
    };

    const handleSubmit = async (evt) => {
        setLoading(true);
        evt.preventDefault();
        setIsValidForm(true);
    };

    return (
        <FormBuilder
            questions={questions}
            answers={contractorFormAnswers}
            onFormAnswered={handleOnFormAnswered}
            handleSubmit={handleSubmit}
            formInstructions={group.instructions}
            defaultGridStyles={true}
            customConfig={{
                autocompleteOptions: {
                    contractorName: customOptions,
                },
            }}
        >
            <StepperNavigationButtons
                handleBack={handleBack}
                handleNext={() => null}
                loading={loading}
                nextButtonDisabled={errorFields}
            />
        </FormBuilder>
    );
}

export default withErrorHandler(ContractorDetailsForm);
